module.exports = __webpack_public_path__ + "static/media/reportIcon.8a96a8f1.svg";